import { Component } from "@angular/core";
import { FormBuilder, Validators, FormGroup } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { HttpClient } from "@angular/common/http";
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../../environments/environment';

@Component({
    selector: "app-login",
    templateUrl: "./login.component.html",
    styleUrls: ["./login.component.scss"]
})
export class LoginComponent {
    public loginForm: FormGroup;
    public showPassword: boolean = false;
    public isLoading: boolean = false;
    private apiUrl = environment.apiUrl;

    constructor(
        private fb: FormBuilder,
        private router: Router,
        private http: HttpClient,
        private toastr: ToastrService,
         private route: ActivatedRoute,
    ) {
        this.loginForm = this.fb.group({
            email: ["", [
                Validators.required,
                Validators.email,
                Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/)
            ]],
            password: ["", [
                Validators.required,
                Validators.minLength(6)
            ]]
        });
    }

    get f() {
        return this.loginForm.controls;
    }

    login() {
        if (this.isLoading || this.loginForm.invalid) {
            this.loginForm.markAllAsTouched();
            this.showFormErrors();
            return;
        }

        this.isLoading = true;

        const loginData = {
            email: this.f['email'].value,
            password: this.f['password'].value
        };

        this.http.post(`${this.apiUrl}auth/signin`, loginData, {
            headers: { 'x-skip-loader': 'true' }
        }).subscribe({
            next: (res: any) => {
                this.isLoading = false;
                if (res.success) {
                    localStorage.setItem('user', JSON.stringify(res.data.user));
                    localStorage.setItem('accessToken', res.data.access_token);

                    this.toastr.success('Login successful!', 'Success', {
                        timeOut: 3000,
                        positionClass: 'toast-top-right',
                        progressBar: true
                    });

                    this.router.navigate(['/warehouse']);

                // const returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/warehouse';
                //     this.router.navigateByUrl(returnUrl);
                }
            },
            error: (err) => {
                this.isLoading = false;
                const msg = err.error?.message || 'Something went wrong.Please try again !';
                this.toastr.error(msg, 'Error');
            }
        });
    }

    togglePasswordVisibility() {
        this.showPassword = !this.showPassword;
    }

    private showFormErrors() {
        Object.keys(this.f).forEach(key => {
            const control = this.f[key];
            if (control.errors) {
                if (key === 'email') {
                    if (control.errors['required']) {
                        this.toastr.error('Email is required.', 'Validation Error');
                    } else if (control.errors['email'] || control.errors['pattern']) {
                        this.toastr.error('Please enter a valid email address.', 'Validation Error');
                    }
                }

                if (key === 'password') {
                    if (control.errors['required']) {
                        this.toastr.error('Password is required.', 'Validation Error');
                    } else if (control.errors['minlength']) {
                        this.toastr.error('Password must be at least 6 characters long.', 'Validation Error');
                    }
                }
            }
        });
    }
}